// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1cWin","errorLogs":"EditorFooter_errorLogs__2RiC4"};